import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";

import CmsEditBanner from "../helpers/cms/CmsEditBanner";
import { useCmsHook } from "../helpers/cms/cmsHook";
import { cmsConstructor } from "../helpers/cms/cmsConstructor";

import SetupGuideHeader from "../components/SetupGuideHeader";

function StaticPricing() {
  const { cmsInstance, setCmsInstance } = useCmsHook();
  // states
  const { pricingCardsData } = useSelector((state) => state.subscription);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.location.pathname === "/static-pricing") {
      const fetchCmsInstance = async () => {
        const cmsObj = await cmsConstructor();
        setCmsInstance(cmsObj);
      };
      fetchCmsInstance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="page-bg-container">
      <SetupGuideHeader />
      {window.location.pathname === "/static-pricing" && (
        <div className="d-flex flex-row justify-content-center">
          <CmsEditBanner />
        </div>
      )}
      <div className="d-flex flex-column justify-content-center align-items-center mt-5">
        <Row className="d-flex flex-row justify-content-center align-items-center h-100 w-100 px-2">
          <Col sm={10} lg={6} className="px-0">
            <Row className="pricing-cards-container mt-5">
              {pricingCardsData &&
                pricingCardsData.map((card) => (
                  <Col md={5} className="pricing-card mb-3 mx-2" key={card.id}>
                    {cmsInstance &&
                      cmsInstance.showRichText(
                        `cmsContent.pricing.${card.id}.header`,
                        "pricing-card-header"
                      )}
                    <hr
                      className="my-2"
                      style={{ border: "1px solid #E0E6EB" }}
                    />
                    {cmsInstance &&
                      cmsInstance.showRichText(
                        `cmsContent.pricing.${card.id}.price`,
                        "pricing-card-price"
                      )}

                    {cmsInstance &&
                      cmsInstance.showRichText(
                        `cmsContent.pricing.${card.id}.points`,
                        "pricing-card-unordered-list"
                      )}
                  </Col>
                ))}
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default StaticPricing;
